import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../api.service';

@Component({
  selector: 'app-schema-assignments',
  templateUrl: './schema-assignments.component.html',
  styleUrls: ['./schema-assignments.component.css']
})
export class SchemaAssignmentsComponent implements OnInit {

  constructor(private api:ApiService) { }

  assignments = [];

  ngOnInit() {
    let request = this.api.getSchemaAssignments();
    request.successFunc = x => this.assignments = x;
    request.start();
  }
}
